import styled, { css } from "styled-components";
import Card from "components/card";
import { Row, styledScroll } from "components/shared/layout";
import colours from "assets/colours";
import { StyledBadge } from "components/badge/styles";
import { fonts } from "assets/fontStyles";
import queries, { devices, maxQuery } from "utils/responsivenessHelper";

const StyledCard = styled(Card)`
  width: 100%;
  box-shadow: 10px 10px 45px rgba(108, 109, 133, 0.15);
  border-radius: 25px;
  padding: 22px 0px;
  overflow: hidden;
`;

const CvHeaderWrapper = styled.div`
  width: 100%;
`;

const CvBody = styled.div`
  overflow: auto;
  max-height: 100%;
  scrollbar-color: ${colours.grey4};
  scrollbar-width: thin;

  ${styledScroll};
`;

const BorderBottom = css`
  position: relative;
  &:after {
    content: "";
    display: flex;
    margin: 0 auto;
    position: absolute;
    bottom: 0;
    height: 1px;
    width: 90%;
    border-bottom: 2px solid ${colours.grey4};
  }
`;

const CvHeader = styled(Row)`
  padding: 0px 34px 22px 34px;
  justify-content: space-between;
  ${({ divider }) =>
    divider &&
    css`
      ${BorderBottom}
    `}

  ${queries.portrait(
    {
      padding: "18px 22px",
      paddingTop: "0px",
    },
    devices.phone
  )}
`;

const CvRow = styled.div`
  display: flex;
  padding: 20px 34px;
  min-height: 102px;
  align-items: center;
  ${BorderBottom}
  cursor: ${(props) => props.clickable && "pointer"}
`;

const CvRowGroup = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
`;

const CvRowWrapper = styled.div`
  display: table-row;
  width: 100%;

  &:last-child {
    margin-bottom: 50px;
  }
`;

const CountBadge = styled(StyledBadge)`
  height: 42px;
  width: 42px;
  min-width: unset;
  max-height: unset;
  font-size: 1.125rem;
  line-height: 120%;
  margin-right: 20px;
  ${queries.portrait({
    height: 36,
    width: 36,
    fontSize: "1rem",
    marginRight: "15px",
  })};
`;

const CardTitle = styled.div`
  font-size: 1.3rem;
  font-weight: 600;
  color: ${colours.zltoDarkBlue};
  line-height: 166%;
  display: contents;
  align-items: center;

  ${queries.both(
    {
      fontSize: "1.2rem",
    },
    devices.phone
  )}

  ${maxQuery.portrait(
    {
      fontSize: "1rem",
    },
    "320px"
  )}
`;

const CardSubtitle = styled.div`
  ${fonts.heading6};
  font-weight: 500;
  line-height: 131%;
  color: ${colours.grey2};
  padding-top: 5px;

  ${queries.both(
    {
      fontSize: "1rem",
    },
    devices.phone
  )}
`;

const AddButtonWrapper = styled.div`
  display: flex;
  margin-left: auto;
  width: 45px;
  height: 45px;
  cursor: pointer;

  button {
    height: inherit;
    width: inherit;
    border-radius: 100%;
    box-shadow: -1.69231px 6.76923px 14.5493px rgba(31, 33, 68, 0.17);
    background: ${colours.white};
    display: flex;
    justify-content: center;
    align-items: center;
    svg {
      path {
        fill: ${colours.zltoLightBlue};
      }
    }
  }

  ${queries.portrait(
    {
      height: 36,
      width: 36,
      fontSize: "1rem",
    },
    devices.phone
  )}
`;

const LogoGroup = styled.div`
  display: flex;
  margin-left: auto;
  position: relative;
  align-items: center;
`;

const Icon = styled.img`
  width: 21px;
  height: 21px;
  position: absolute;
  bottom: -5px;
  left: 0px;
  border-radius: 100%;
  box-shadow: 0px 3.17647px 7.94118px rgba(0, 0, 0, 0.15);
`;

const CvRowTitle = styled.div`
  font-weight: 600;
  font-size: 1.125rem;
  line-height: 166%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  color: ${colours.zltoDarkBlue};

  ${queries.both(
    {
      fontSize: "1rem",
    },
    devices.phone
  )}
`;

const CvRowSubtitle = styled(CvRowTitle)`
  color: ${colours.grey2};
  font-size: 0.875rem;
  ${queries.both(
    {
      fontSize: "0.78rem",
    },
    devices.phone
  )}
`;

const ViewIcon = styled.img`
  transform: rotate(270deg);
  display: flex;
  cursor: pointer;
`;

const EmptyMessage = styled(Row)`
  ${fonts.heading6};
  color: ${colours.grey2};
  line-height: 131%;
  font-weight: normal;
  width: 100%;
  padding-top: 3.5em;
  justify-content: center;
  max-width: 80%;
  text-align: center;
  margin: 0 auto;

  ${queries.both({
    paddingTop: "1.5em",
  })}
`;

const LogoCount = styled.div`
  background: ${colours.zltoDarkBlue};
  color: ${colours.white};
  width: 22px;
  height: 22px;
  position: absolute;
  top: 0;
  right: -10px;
  border-radius: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 0.75rem;
`;

export {
  StyledCard,
  CvHeaderWrapper,
  CvHeader,
  CvBody,
  CvRow,
  CountBadge,
  CardTitle,
  CardSubtitle,
  AddButtonWrapper,
  LogoGroup,
  LogoCount,
  Icon,
  CvRowTitle,
  CvRowSubtitle,
  CvRowWrapper,
  ViewIcon,
  CvRowGroup,
  EmptyMessage,
};
